module.exports = __webpack_public_path__ + "img/covid19.1bd2be81.png";